import { useSearchParams } from 'react-router-dom';

import { useState } from 'react';
import DeductionsModal from './DeductionBody';
import styles from './index.module.scss';

const DeductionTab = (props: any) => {
	const { activeTab, isUsd } = props;
	const [searchParams] = useSearchParams();
	const [earningsAmount, setEarningsAmount] = useState<number>(0);
	const [earningsAmountZMW, setEarningsAmountZMW] = useState<number>(0);
	const [hasMixedCurrency, setHasMixedCurrency] = useState<boolean>(false);

	const [isFetchDataLoading, setIsFetchDataLoading] =
		useState<boolean>(false);

	return (
		<div>
			<div className={styles.deductionContainer}>
				<div className={styles.headerBox}>
					<div className={styles.headerContent}>
						<div className={styles.titleContainer}>
							<div className={styles.titleText}>
								{'Deductions'}
							</div>
							<div className={styles.separation}></div>
							<div className={styles.earningsCount}>
								<div className={styles.titleEarnings}>
									Total Deductions
								</div>
								<div className={styles.amountsGroup}>
									<div className={styles.earningsAmount}>
										<span className={styles.currencyLabel}>
											{isUsd ? '$' : 'ZMW'}
										</span>
										{!isFetchDataLoading &&
											earningsAmount != null &&
											earningsAmount?.toFixed(2)}
									</div>
									{hasMixedCurrency && (
										<>
											<span className={styles.amountsJoiner}>+</span>
											<div className={styles.earningsAmount}>
												<span className={styles.currencyLabel}>ZMW</span>
												{!isFetchDataLoading &&
													earningsAmountZMW != null &&
													earningsAmountZMW?.toFixed(2)}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<DeductionsModal
					activeTab={activeTab}
					employeeId={searchParams.get('employeeId') as string}
					isUSD={isUsd}
					isLoading={isFetchDataLoading}
					setIsLoading={setIsFetchDataLoading}
					setEarningsAmount={setEarningsAmount}
					setEarningsAmountZMW={setEarningsAmountZMW}
					setHasMixedCurrency={setHasMixedCurrency}
				/>
			</div>
		</div>
	);
};

export default DeductionTab;
